<body class="generate-token main-container">
  <div class="cstm-header-v1">
    @if (title_image_id) {
      <div class="header-sl">
        <img class="sctm-top-header-img" [src]="title_image_id | secure  | async" loading="lazy" alt="">
      </div>
    }
  </div>
  @if (!title_image_id) {
    <div class="_wf-top-main-contain">
      <div class="_wf-top-time-contain hide">
        <div class="_wf-top-time-contain__week">
          <div class="_wf-header-date font-color">{{now | date: 'dMMM'}}</div>
        </div>
        <div class="_wf-top-time-contain__time">
          <div class="_wf-header-time font-color">{{now | date: 'h:mm a'}}</div>
        </div>
      </div>
    </div>
  }
  <div class="_wf-welcome-txt">
    <h1 class="_wf-h2-center">{{"field.label.welcome_label" | translate | async}} <span class="text-up pl-1">
    {{this.appService.getOrganization().org_name.toLowerCase()}}</span></h1>
    <h3 class="_wf-h3-center select-serice">{{"field.label.Select_A_Service" | translate | async}} <span class="arrow-circle"><i class="fa fa-angle-right" aria-hidden="true"></i></span></h3>
  </div>
  @if (result) {
    <div class="_wf-services-contain">
      @for (r of result; track r; let i = $index) {
        <div class="_wf-service__item" id="{{r.id}}" [ngClass]="{'active' : selectedserviceId == r.id}" (click)="openAppointment(r)">
          <a class="_wf-service__item-link w-inline-block _wf-service__service_box">
            <div class="_wf-service__icon">
              @if (!r.logo_profile_path) {
                <img src="assets/images/token/getToken.png" loading="lazy" alt="" class="image gt-token-icon">
              }
              @if (r.logo_profile_path) {
                <img [src]="r.logo_profile_path | secure  | async" loading="lazy" alt="" class="image gt-token-icon">
              }
            </div>
            <div class="_wf-service__label">
              <h5 class="_wf-h5-center text-bold">{{r.display_name}}</h5>
            </div>
          </a>
        </div>
      }
    </div>
  }
  @if (result) {
    <span>
      @if (result.length == 0) {
        <div class="_wf-services-contain">
          <h1 class="_wf-h2-center select-serice text-bold">{{"field.label.No_Service_Found" | translate | async}}</h1>
        </div>
      }
    </span>
  }
  <div class="container text-box" (click)="checkServiceSelection()">
    <div class="input-container" id="r">
      <input class="input-field" name="phoneNumber" placeholder='{{"field.label.mobile_number_placeholder" | translate | async}}' type="number" [(ngModel)]="phoneNumber" onKeyPress="if(this.value.length==12) return false;" required />
      <i class="fa fa-qrcode qrcode-icon" [ngClass]="{'disabled-icon': !selectedData}" (click)="selectedData ? hasQrCodeScanner() : null"> </i>
    </div>
    <div>
      <div class="button-container">
        <div class="_wf-txt-btmhd">
          <button class="secondary-btn font-color text-bold" type="button" id="button-addon1" (click)="submitData($event)" [disabled]="disableBtn">
            {{'menu.get_token' | translate | async}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="no-phone-container">
    <a class="no-phone-link" (click)="getTokenWithoutPhone($event)">{{'field.label.no_phone_get_token' | translate | async}}</a>
  </div>
  @if (!showToken && tokenNumber) {
    <div class="_wf-btmtab-div">
      <div class="_wf-tab-main">
        <div class="_wf-tab-bg-2">
          <div class="_wf-txt-btmhd-2">
            <div class="_wf-txt-thanks _wf-thank-txt">
              <div class="text-block-25">{{'field.label.thank_you_note' | translate | async}}</div>
            </div>
            <div class="_wf-token">
              <div class="text-block-26">
              {{'field.label.token_no_msg' | translate | async}} {{tokenNumber}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</body>